export const tagRegexpGroupName = 'tag' as const

const tagPattern = `{(?<${tagRegexpGroupName}>[^}{]+?)}`
export const getTagsRegexp = (flags = '') => new RegExp(tagPattern, flags)
